import _ from "lodash";

export const ReqModeDroOpts = () => {
    const MODE = {
        AN: "Credit Note(AN)",
        TT: "Telegraphic Transfer(TT)",
        WN: "Waiver(WN)"
    };

    const getReqModeModel = () => {
        let ret = MODE;

        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    const getKeyByValue = (value: string) => {
        const reqMode: { [x: string]: string } = { ...MODE };
        return Object.keys(reqMode)?.find(key => reqMode[key] === value) ?? "";
    }

    const getValueByKey = (key: string) => {
        const reqMode: { [x: string]: string } = { ...MODE };
        return reqMode[key] ?? "";
    }

    return {
        getValueByKey,
        getKeyByValue,
        getReqModeModel,
    }
}